import React from "react";
import Slider from "./slieder";
import { motion } from "framer-motion";
import FooterwithoutLogin from "./footerwithoutLogin";
import SEO from "../SEO/seo";

const NetHouse = () => {
  const fadeUp = {
    hidden: { opacity: 0, y: 30 },
    visible: { opacity: 1, y: 0 },
  };

  const scaleFade = {
    hidden: { opacity: 0, scale: 0.9 },
    visible: { opacity: 1, scale: 1 },
  };

  const imageZoom = {
    hidden: { scale: 1.05, opacity: 0 },
    visible: { scale: 1, opacity: 1 },
  };

  const slideLeftToRight = {
    hidden: { opacity: 0, x: -100 },
    visible: { opacity: 1, x: 0 },
  };

  const slideRightT0Left = {
    hidden: { opacity: 0, x: 100 },
    visible: { opacity: 1, x: 0 },
  };
  return (
    <>
      <SEO
        title="Kryzen Nethouse / Shadehouse | Insect-Protected Farming Structures"
        description="Discover Kryzen Nethouse and Shadehouse structures — durable greenhouse alternatives made with galvanized steel and insect-proof nets. Maintain ideal conditions for healthy crop growth with natural airflow, heat, and humidity control."
        keywords="nethouse farming, shadehouse farming, kryzen nethouse, insect-proof greenhouse, crop protection nets, controlled farming environment, greenhouse with net, cost-effective farming structure"
        canonical="https://alpha.kryzen.com/kryzen-nethouse-shadehouse"
        ogTitle="Kryzen Nethouse / Shadehouse"
        ogDescription="Kryzen Nethouses and Shadehouses are smart farming structures that balance light, air, and moisture using insect-proof nets. Ideal for growing disease-free, healthy crops with cost-effective protection."
        ogImage="https://res.cloudinary.com/bsgfcooa/image/upload/v1752217358/31_xvu3ng.jpg"
        twitterTitle="Kryzen Nethouse / Shadehouse | Insect-Protected Farming Structures"
        twitterDescription="Discover Kryzen Nethouse and Shadehouse structures — durable greenhouse alternatives made with galvanized steel and insect-proof nets. Maintain ideal conditions for healthy crop growth with natural airflow, heat, and humidity control."
      />
      <Slider
        heding={"nethouse / shadehouse"}
        paragraph={
          "A net house is a kind of greenhouse. A net house is a mechanical structure made using galvanized steel covered by nets or insect nets. Such net houses allow an only appropriate amount of heat, air and moisture to pass through them to create the required climatic conditions for the better growth of the plant. This way the net houses allow the plants to grow the healthiest."
        }
      />
      <div className="container mainDiv py-5">
        <div className="text-center py-5 px-3">
          <motion.h1
            initial="hidden"
            whileInView="visible"
            viewport={{ once: false, amount: 0.3 }}
            variants={fadeUp}
            transition={{ duration: 0.7 }}
            className="display-md-4 display-lg-4 display-5 fw-bold text-uppercase text-success mb-2"
          >
            Kryzen Nethouse / Shadehouse
          </motion.h1>

          <hr></hr>
          <motion.p
            initial="hidden"
            whileInView="visible"
            viewport={{ once: false, amount: 0.3 }}
            variants={fadeUp}
            transition={{ duration: 0.6, delay: 0.2 }}
            className="lead mx-auto p-5"
            style={{ lineHeight: "1.8", fontSize: "25px" }}
          >
            A net house is a future of farming that everybody is looking forward
            to. It is only because it can withstand the harsh climatic
            conditions in areas like Rajasthan and Uttar Pradesh, where there is
            also low water supply and other situations that make farming with
            traditional methods hard. This is where the Net House Farming comes
            into existence. Let’s read on to learn more about what is a net
            house, net house farming and the greenhouse net benefit for the
            agricultural field.
          </motion.p>
        </div>
        <div className="row g-5 align-items-stretch mb-5">
          <div className="col-md-4">
            <motion.div
              className="card border-0 h-100"
              initial="hidden"
              whileInView="visible"
              viewport={{ once: false, amount: 0.3 }}
              variants={scaleFade}
              transition={{ duration: 0.5 }}
            >
              <motion.img
                initial="hidden"
                whileInView="visible"
                viewport={{ once: false, amount: 0.3 }}
                variants={imageZoom}
                transition={{ duration: 0.6 }}
                src="https://res.cloudinary.com/bsgfcooa/image/upload/v1752217358/30-1_ax4rki.jpg"
                alt="Flat Roof Shade Net Houses?"
                className="card-img-top img-fluid"
                style={{ maxHeight: "350px", objectFit: "cover" }}
              />
              <div className="card-body p-4">
                <h5 className="card-title fs-3 fw-semibold mb-3 text-primary">
                  Flat Roof Shade Net Houses
                </h5>
                <p
                  className="card-text text-secondary"
                  style={{ lineHeight: "1.8", fontSize: "1.05rem" }}
                >
                  These are specially designed agricultural structures that help
                  control light and heat to create the perfect growing
                  environment for crops. With flat roofs made from durable
                  polyethene, these shade net houses are supported by materials
                  like galvanised steel pipes. Their main purpose is to regulate
                  temperature and light, ensuring optimal conditions for plant
                  growth.
                </p>
              </div>
            </motion.div>
          </div>

          <div className="col-md-4">
            <motion.div
              className="card border-0 h-100"
              initial="hidden"
              whileInView="visible"
              viewport={{ once: false, amount: 0.3 }}
              variants={scaleFade}
              transition={{ duration: 0.5, delay: 0.2 }}
            >
              <img
                src="https://res.cloudinary.com/bsgfcooa/image/upload/v1752217358/29-2_yjragp.jpg"
                alt="Dome-shaped shade net houses"
                className="card-img-top img-fluid"
                style={{ maxHeight: "350px", objectFit: "cover" }}
              />
              <div className="card-body p-4">
                <h5 className="card-title fs-3 fw-semibold mb-3 text-primary">
                  Dome-shaped shade net houses
                </h5>
                <p
                  className="card-text text-secondary"
                  style={{ lineHeight: "1.8", fontSize: "1.05rem" }}
                >
                  These are designed to provide excellent flexibility in size
                  and dimensions to meet various farming needs. Unlike flat roof
                  designs, the dome shape promotes better air circulation, even
                  light distribution, and efficient water runoff, while also
                  reducing wind resistance. This makes dome-shaped shade net
                  houses more durable and less susceptible to damage.
                </p>
              </div>
            </motion.div>
          </div>
          <div className="col-md-4">
            <motion.div
              className="card border-0 h-100"
              initial="hidden"
              whileInView="visible"
              viewport={{ once: false, amount: 0.3 }}
              variants={scaleFade}
              transition={{ duration: 0.5, delay: 0.2 }}
            >
              <img
                src="https://res.cloudinary.com/bsgfcooa/image/upload/v1752217358/31_xvu3ng.jpg"
                alt="Dome-shaped shade net houses"
                className="card-img-top img-fluid"
                style={{ maxHeight: "350px", objectFit: "cover" }}
              />
              <div className="card-body p-4">
                <h5 className="card-title fs-3 fw-semibold mb-3 text-primary">
                  A wire rope nethouse
                </h5>
                <p
                  className="card-text text-secondary"
                  style={{ lineHeight: "1.8", fontSize: "1.05rem" }}
                >
                  This is a type of shade net house that uses wire ropes for
                  structural support, providing a sturdy framework for crop
                  protection. The wire ropes, typically made of galvanized
                  steel, form the support for the netting, which helps regulate
                  light, temperature, and airflow. This design ensures that the
                  nethouse can withstand harsh weather conditions.
                </p>
              </div>
            </motion.div>
          </div>
        </div>
        <div
          className="mt-7 py-5"
          style={{
            background:
              "color-mix(in srgb,rgb(255, 208, 143) 10%, transparent)",
            color: "black",
            border: `1px solid color-mix(in srgb, #f59f00 20%, transparent)`,
            padding: "1rem",
            borderRadius: "0.25rem",
          }}
        >
          <div className="row">
            <div className="col-12">
              <h3 className="text-success fw-bold mb-4">
                Technical Specifications
              </h3>
              <div className="table-responsive">
                <table className="table table-bordered align-middle">
                  <tbody>
                    <tr>
                      <th scope="row">Wind Load</th>
                      <td>0.5 KN/m²</td>
                    </tr>
                    <tr>
                      <th scope="row">Snow Load</th>
                      <td>0.35 KN/m²</td>
                    </tr>
                    <tr>
                      <th scope="row">Maximum Drainage Capacity</th>
                      <td>140 mm/h</td>
                    </tr>
                    <tr>
                      <th scope="row">Span Width</th>
                      <td>4m, 8m, 9.6m, 10.8m, 12.8m or customized</td>
                    </tr>
                    <tr>
                      <th scope="row">Column Spacing</th>
                      <td>4.0m, 8.0m or customized</td>
                    </tr>
                    <tr>
                      <th scope="row">Shoulder Height</th>
                      <td>3.0m – 6.0m or customized</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>

            <div className="col-12 mt-5">
              <p
                style={{
                  fontSize: "1.05rem",
                  lineHeight: "1.8",
                  color: "#444",
                }}
              >
                The agricultural industry faces tough challenges due to extreme
                weather and unpredictable rainfall. But thanks to modern
                innovations like the nethouse, farming is no longer restricted
                to specific locations. You can now grow almost anything,
                anywhere! A nethouse, also known as a shade net house, is a
                special type of greenhouse made with galvanized steel and
                covered by nets. These nets control the amount of heat, air, and
                moisture that enters, creating the perfect environment for crops
                to thrive. This makes it ideal for regions with tough conditions
                like Rajasthan and Uttar Pradesh, where traditional farming
                struggles due to harsh weather and low water availability.
                Nethouses are the future of farming, offering a reliable
                solution to grow healthy crops in any climate. If you’re
                interested in learning more about shade net houses and how they
                can benefit agriculture, keep reading to discover their
                advantages for modern farming!
              </p>
            </div>
          </div>
        </div>
        <h1 className="display-6 fw-bold text-uppercase text-center mb-2 mt-7">
          Different Shade Factors of Net House.
        </h1>
        <motion.p
          initial="hidden"
          whileInView="visible"
          viewport={{ once: false, amount: 0.3 }}
          variants={fadeUp}
          transition={{ duration: 0.6, delay: 0.2 }}
          className="lead mx-auto p-5 text-center"
          style={{ lineHeight: "1.8", fontSize: "25px" }}
        >
          Shade net houses are constructed using polyethylene material and come
          in various shade factors. For example, a 40% shade factor means that
          40% of the light intensity is blocked, while the remaining 60% is
          allowed to pass through the net.
        </motion.p>
        <hr></hr>{" "}
        <div className="row g-5 align-items-stretch mt-7">
          {/* Left Column */}
          <div className="col-md-6">
            <motion.div
              className="card border-0 h-100 p-3"
              initial="hidden"
              whileInView="visible"
              viewport={{ once: false, amount: 0.3 }}
              variants={slideLeftToRight}
              transition={{ duration: 0.5, delay: 0.2 }}
            >
              <img
                src="https://res.cloudinary.com/bsgfcooa/image/upload/v1752218479/66_zwskrd.jpg"
                alt="What is a Polyhouse?"
                className="card-img-top img-fluid"
                style={{ width: "100%", height: "300px" }}
              />
              <div className="card-body p-4">
                <h5 className="card-title fs-3 fw-semibold mb-3 text-primary">
                  Different Shade Factors before you buy a Net House
                </h5>
                <motion.p
                  initial="hidden"
                  whileInView="visible"
                  viewport={{ once: false, amount: 0.3 }}
                  variants={fadeUp}
                  transition={{ duration: 0.6, delay: 0.2 }}
                  className="card-text text-secondary"
                  style={{ lineHeight: "1.8", fontSize: "1.05rem" }}
                >
                  Before you buy a shade net house, it is significant to
                  understand the different Shade Factors available in a net
                  house. Net houses are designed using polyethene material, but
                  they come in various Shade Factors like 40% Shade Factor
                  implies that 40% light intensity will be blocked, and the rest
                  60% light intensity will be allowed to pass through the shade
                  net.
                </motion.p>
              </div>
            </motion.div>
          </div>
          {/* Right Column */}
          <div className="col-md-6">
            <motion.div
              className="card border-0  h-100"
              initial="hidden"
              whileInView="visible"
              viewport={{ once: false, amount: 0.3 }}
              variants={slideRightT0Left}
              transition={{ duration: 0.5, delay: 0.2 }}
            >
              <div className="section my-4 py-4">
                <div className="row text-center my-6">
                  {/* <h2 className="hero-title display-6 fw-bold">FAQ's</h2> */}
                  <h3 className="section-description my-0 p-0">
                    Different Shade Factors of Net House.
                  </h3>
                </div>

                <div className="row m-2">
                  <div className="">
                    <div class="accordion" id="accordion-default">
                      <div class="accordion-item">
                        <div class="accordion-header">
                          <button
                            class="accordion-button collapsed"
                            type="button"
                            data-bs-toggle="collapse"
                            data-bs-target="#collapse-1-default"
                            aria-expanded="false"
                          >
                            15% Shade Factor
                            <div class="accordion-button-toggle"></div>
                          </button>
                        </div>
                        <div
                          id="collapse-1-default"
                          class="accordion-collapse collapse"
                          data-bs-parent="#accordion-default"
                        >
                          <div class="accordion-body">
                            15% of sunlight is obstructed, & 85% sunlight is
                            passed.
                          </div>
                        </div>
                      </div>

                      <div class="accordion-item">
                        <div class="accordion-header">
                          <button
                            class="accordion-button collapsed"
                            type="button"
                            data-bs-toggle="collapse"
                            data-bs-target="#collapse-2-default"
                            aria-expanded="false"
                          >
                            35% Shade Factor
                            <div class="accordion-button-toggle"></div>
                          </button>
                        </div>
                        <div
                          id="collapse-2-default"
                          class="accordion-collapse collapse"
                          data-bs-parent="#accordion-default"
                        >
                          <div class="accordion-body">
                            35% of sunlight is obstructed, & 65% sunlight is
                            passed.
                          </div>
                        </div>
                      </div>
                      <div class="accordion-item">
                        <div class="accordion-header">
                          <button
                            class="accordion-button collapsed"
                            type="button"
                            data-bs-toggle="collapse"
                            data-bs-target="#collapse-3-default"
                            aria-expanded="false"
                          >
                            40% Shade Factor
                            <div class="accordion-button-toggle"></div>
                          </button>
                        </div>
                        <div
                          id="collapse-3-default"
                          class="accordion-collapse collapse"
                          data-bs-parent="#accordion-default"
                        >
                          <div class="accordion-body">
                            40% of sunlight is obstructed, & 60% sunlight is
                            passed
                          </div>
                        </div>
                      </div>
                      <div class="accordion-item">
                        <div class="accordion-header">
                          <button
                            class="accordion-button collapsed"
                            type="button"
                            data-bs-toggle="collapse"
                            data-bs-target="#collapse-4-default"
                            aria-expanded="false"
                          >
                            50% Shade Factor
                            <div class="accordion-button-toggle"></div>
                          </button>
                        </div>
                        <div
                          id="collapse-4-default"
                          class="accordion-collapse collapse"
                          data-bs-parent="#accordion-default"
                        >
                          <div class="accordion-body">
                            50% of sunlight is obstructed, & 50% sunlight is
                            passed.
                          </div>
                        </div>
                      </div>
                      <div class="accordion-item">
                        <div class="accordion-header">
                          <button
                            class="accordion-button collapsed"
                            type="button"
                            data-bs-toggle="collapse"
                            data-bs-target="#collapse-5-default"
                            aria-expanded="false"
                          >
                            75% Shade Factor
                            <div class="accordion-button-toggle"></div>
                          </button>
                        </div>
                        <div
                          id="collapse-5-default"
                          class="accordion-collapse collapse"
                          data-bs-parent="#accordion-default"
                        >
                          <div class="accordion-body">
                            75% of sunlight is obstructed, & 25% sunlight is
                            passed.
                          </div>
                        </div>
                      </div>
                      <div class="accordion-item">
                        <div class="accordion-header">
                          <button
                            class="accordion-button collapsed"
                            type="button"
                            data-bs-toggle="collapse"
                            data-bs-target="#collapse-6-default"
                            aria-expanded="false"
                          >
                            90% Shade Factor
                            <div class="accordion-button-toggle"></div>
                          </button>
                        </div>
                        <div
                          id="collapse-6-default"
                          class="accordion-collapse collapse"
                          data-bs-parent="#accordion-default"
                        >
                          <div class="accordion-body">
                            90% of sunlight is obstructed, & 10% sunlight is
                            passed.
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </motion.div>
          </div>
        </div>
        <div className="text-center py-5 px-3 mt-7">
          <motion.h1
            initial="hidden"
            whileInView="visible"
            viewport={{ once: false, amount: 0.3 }}
            variants={fadeUp}
            transition={{ duration: 0.7 }}
            className="display-md-4 display-lg-4 display-6 fw-bold text-uppercase"
          >
            Protected cultivation Structure : ISI MADE
          </motion.h1>

          <hr></hr>
        </div>
        <div className="row g-5 align-items-stretch">
          {/* Left Column */}
          <div className="col-md-3">
            <motion.div
              className="card border-0  h-100"
              initial="hidden"
              whileInView="visible"
              viewport={{ once: false, amount: 0.3 }}
              variants={slideLeftToRight}
              transition={{ duration: 0.6 }}
            >
              <img
                src="https://res.cloudinary.com/bsgfcooa/image/upload/v1752149137/hot_deep_z3hels.jpg"
                alt="What is a Polyhouse?"
                className="card-img-top img-fluid p-2"
                style={{ width: "100%", height: "280px" }}
              />
              <div className="card-body p-4">
                <h5 className="card-title fs-3 fw-semibold mb-3 text-primary">
                  Hot DIP Galvanized Steel
                </h5>
                <p
                  className="card-text text-secondary"
                  style={{ lineHeight: "1.8", fontSize: "1.05rem" }}
                >
                  The entire structure is made up of GI Steel, giving a very
                  high lifespan to construction as the whole.
                </p>
              </div>
            </motion.div>
          </div>

          <div className="col-md-3">
            <motion.div
              className="card border-0  h-100"
              initial="hidden"
              whileInView="visible"
              viewport={{ once: false, amount: 0.3 }}
              variants={slideLeftToRight}
              transition={{ duration: 0.6 }}
            >
              <img
                src="https://res.cloudinary.com/bsgfcooa/image/upload/v1752149137/net_rdh638.jpg"
                alt="Grrenhouse Benefits"
                className="card-img-top img-fluid p-2"
                style={{ width: "100%", height: "280px" }}
              />
              <div className="card-body p-4">
                <h5 className="card-title fs-3 fw-semibold mb-3 text-primary">
                  Fibre-threaded Insect net
                </h5>
                <p
                  className="card-text text-secondary"
                  style={{ lineHeight: "1.8", fontSize: "1.05rem" }}
                >
                  Good quality insect net which lets air pass freely but
                  obstruct insects, rodents & birds from entering inside.
                </p>
              </div>
            </motion.div>
          </div>

          {/* Right Column */}
          <div className="col-md-3">
            <motion.div
              className="card border-0  h-100"
              initial="hidden"
              whileInView="visible"
              viewport={{ once: false, amount: 0.3 }}
              variants={slideRightT0Left}
              transition={{ duration: 0.6 }}
            >
              <img
                src="https://res.cloudinary.com/bsgfcooa/image/upload/v1752149136/alunium_d8gnik.jpg"
                alt="Grrenhouse Benefits"
                className="card-img-top img-fluid p-2"
                style={{ width: "100%", height: "280px" }}
              />
              <div className="card-body p-4">
                <h5 className="card-title fs-3 fw-semibold mb-3 text-primary">
                  Aluminum / GI Accessories
                </h5>
                <p
                  className="card-text text-secondary"
                  style={{ lineHeight: "1.8", fontSize: "1.05rem" }}
                >
                  All small to big accessories are made up of Aluminium or GI,
                  making sure the structure core has zero weak links.
                </p>
              </div>
            </motion.div>
          </div>
          <div className="col-md-3">
            <motion.div
              className="card border-0  h-100"
              initial="hidden"
              whileInView="visible"
              viewport={{ once: false, amount: 0.3 }}
              variants={slideRightT0Left}
              transition={{ duration: 0.6 }}
            >
              <img
                src="https://res.cloudinary.com/bsgfcooa/image/upload/v1752149137/layer_ibrkap.jpg"
                alt="Grrenhouse Benefits"
                className="card-img-top img-fluid p-2"
                style={{ width: "100%", height: "280px" }}
              />
              <div className="card-body p-4">
                <h5 className="card-title fs-3 fw-semibold mb-3 text-primary">
                  200M-7Layer Polyfilm
                </h5>
                <p
                  className="card-text text-secondary"
                  style={{ lineHeight: "1.8", fontSize: "1.05rem" }}
                >
                  7 Layer Polyfilm ensures good quality and quantity of sunlight
                  (light wavelengths) reaches the plants.
                </p>
              </div>
            </motion.div>
          </div>
        </div>
        <div className="text-center py-5 px-3 mt-7">
          <motion.h1
            initial="hidden"
            whileInView="visible"
            viewport={{ once: false, amount: 0.3 }}
            variants={fadeUp}
            transition={{ duration: 0.7 }}
            className="display-md-4 display-lg-4 display-6 fw-bold text-uppercase"
          >
            crop shading solution
          </motion.h1>

          <hr></hr>
        </div>
        <div className="row g-5 align-items-stretch">
          {/* Left Column */}
          <div className="col-md-4">
            <div
              className="card border-0 shadow-sm h-100"
              onMouseEnter={(e) => {
                e.currentTarget.classList.add("shadow-lg");
              }}
              onMouseLeave={(e) => {
                e.currentTarget.classList.remove("shadow-lg");
              }}
            >
              <img
                src="https://res.cloudinary.com/bsgfcooa/image/upload/v1752206370/aluminet_fexoch.jpg"
                alt="What is a Polyhouse?"
                className="card-img-top img-fluid p-2"
                style={{ width: "100%", height: "280px" }}
              />
              <div className="card-body p-4">
                <h5 className="card-title fs-3 fw-semibold mb-3 text-primary">
                  kryzen aluminet (heat repellent)
                </h5>
              </div>
            </div>
          </div>

          <div className="col-md-4">
            <div
              className="card border-0 shadow-sm h-100"
              onMouseEnter={(e) => {
                e.currentTarget.classList.add("shadow-lg");
              }}
              onMouseLeave={(e) => {
                e.currentTarget.classList.remove("shadow-lg");
              }}
            >
              <img
                src="https://res.cloudinary.com/bsgfcooa/image/upload/v1752206369/shadenet_uw5zjl.jpg"
                alt="Grrenhouse Benefits"
                className="card-img-top img-fluid p-2"
                style={{ width: "100%", height: "280px" }}
              />
              <div className="card-body p-4">
                <h5 className="card-title fs-3 fw-semibold mb-3 text-primary">
                  kryzen Shadenet (30% / 50% / 70%)
                </h5>
              </div>
            </div>
          </div>

          {/* Right Column */}
          <div className="col-md-4">
            <div
              className="card border-0 shadow-sm h-100"
              onMouseEnter={(e) => {
                e.currentTarget.classList.add("shadow-lg");
              }}
              onMouseLeave={(e) => {
                e.currentTarget.classList.remove("shadow-lg");
              }}
            >
              <img
                src="https://res.cloudinary.com/bsgfcooa/image/upload/v1752206369/insetnet_dyalyp.jpg"
                alt="Grrenhouse Benefits"
                className="card-img-top img-fluid p-2"
                style={{ width: "100%", height: "280px" }}
              />
              <div className="card-body p-4">
                <h5 className="card-title fs-3 fw-semibold mb-3 text-primary">
                  kryzen insect net
                </h5>
              </div>
            </div>
          </div>
        </div>
        <div>
          <div
            className="container  py-5 mt-7"
            style={{
              background:
                "color-mix(in srgb,rgb(204, 255, 204) 15%, transparent)",
              color: "#000",
              border: "1px solid #c0e6b6",
              borderRadius: "8px",
              padding: "1rem",
            }}
          >
            <h3 className="text-success fw-bold mb-4">
              Optional Intelligent Polytunnel Add-ons
            </h3>

            <div className="table-responsive">
              <table className="table table-bordered table-striped align-middle">
                <thead className="table-success">
                  <tr>
                    <th style={{ width: "25%" }}>Add-on</th>
                    <th>Description</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <th scope="row">Steel Structure</th>
                    <td>Hot-galvanized steel pipe</td>
                  </tr>
                  <tr>
                    <th scope="row">Greenhouse Glass</th>
                    <td>Different models can be selected</td>
                  </tr>
                  <tr>
                    <th scope="row">Sun-shading Net</th>
                    <td>
                      Summer shade, block rain, moisture, cooling, winter/spring
                      heat preservation
                    </td>
                  </tr>
                  <tr>
                    <th scope="row">Cooling System</th>
                    <td>
                      The fan forms negative pressure and the water curtain
                      cools down
                    </td>
                  </tr>
                  <tr>
                    <th scope="row">Heating System</th>
                    <td>
                      Thermal insulation series, air heater, boiler and pipe
                      heating, air circulating fan
                    </td>
                  </tr>
                  <tr>
                    <th scope="row">Ventilation System</th>
                    <td>Side windows and cooling fans</td>
                  </tr>
                  <tr>
                    <th scope="row">
                      Water & Fertilizer Integrated Irrigation System
                    </th>
                    <td>
                      Sprinkler irrigation series, drip irrigation series,
                      intelligent mobile sprinkler irrigation
                    </td>
                  </tr>
                  <tr>
                    <th scope="row">Automatic Control System</th>
                    <td>
                      Automatic control technology that can independently drive
                      intelligent machines to achieve control objectives without
                      human intervention
                    </td>
                  </tr>
                  <tr>
                    <th scope="row">Fill-in Light</th>
                    <td>
                      Easy assemble auto light deprivation blackout greenhouse
                    </td>
                  </tr>
                  <tr>
                    <th scope="row">Seedling Bed</th>
                    <td>Movable seeding bed</td>
                  </tr>
                  <tr>
                    <th scope="row">Hydroponics</th>
                    <td>
                      It is reusable, requires no nutrient additions, and is
                      both convenient and inexpensive.
                    </td>
                  </tr>
                  <tr>
                    <th scope="row">External & Internal Shading System</th>
                    <td>The gear rack drives the shading system</td>
                  </tr>
                  <tr>
                    <th scope="row">Photovoltaic System</th>
                    <td>For solar power generation</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <hr></hr>
      </div>
      <FooterwithoutLogin></FooterwithoutLogin>
    </>
  );
};

export default NetHouse;
